import { jsx as o, jsxs as b } from "react/jsx-runtime";
import { useContext as z, useId as D, useState as G, createContext as F } from "react";
function V(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var x = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var w;
function Z() {
  return w || (w = 1, function(t) {
    (function() {
      var p = {}.hasOwnProperty;
      function n() {
        for (var r = "", e = 0; e < arguments.length; e++) {
          var a = arguments[e];
          a && (r = i(r, u(a)));
        }
        return r;
      }
      function u(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return n.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var e = "";
        for (var a in r)
          p.call(r, a) && r[a] && (e = i(e, a));
        return e;
      }
      function i(r, e) {
        return e ? r ? r + " " + e : r + e : r;
      }
      t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
    })();
  }(x)), x.exports;
}
var J = Z();
const K = /* @__PURE__ */ V(J), f = {
  "purpur-heading": "_purpur-heading_k9fhq_1",
  "purpur-heading--hyphens": "_purpur-heading--hyphens_k9fhq_8",
  "purpur-heading--negative": "_purpur-heading--negative_k9fhq_11",
  "purpur-heading--subsection-100": "_purpur-heading--subsection-100_k9fhq_14",
  "purpur-heading--title-100": "_purpur-heading--title-100_k9fhq_20",
  "purpur-heading--title-200": "_purpur-heading--title-200_k9fhq_26",
  "purpur-heading--title-300": "_purpur-heading--title-300_k9fhq_32",
  "purpur-heading--title-400": "_purpur-heading--title-400_k9fhq_38",
  "purpur-heading--title-500": "_purpur-heading--title-500_k9fhq_44",
  "purpur-heading--title-600": "_purpur-heading--title-600_k9fhq_50",
  "purpur-heading--title-700": "_purpur-heading--title-700_k9fhq_56",
  "purpur-heading--display-25": "_purpur-heading--display-25_k9fhq_62",
  "purpur-heading--display-50": "_purpur-heading--display-50_k9fhq_68",
  "purpur-heading--display-100": "_purpur-heading--display-100_k9fhq_74",
  "purpur-heading--display-200": "_purpur-heading--display-200_k9fhq_80"
}, Q = {
  TITLE100: "title-100"
}, m = "purpur-heading", $ = ({
  children: t,
  className: p = "",
  enableHyphenation: n = !1,
  negative: u = !1,
  tag: i,
  variant: r = Q.TITLE100,
  ...e
}) => {
  const a = i, s = K([
    p,
    f[m],
    f[`${m}--${r}`],
    {
      [f[`${m}--hyphens`]]: n,
      [f[`${m}--negative`]]: u
    }
  ]);
  return /* @__PURE__ */ o(a, { className: s, ...e, children: t });
};
$.displayName = "Heading";
function U(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var v = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var q;
function W() {
  return q || (q = 1, function(t) {
    (function() {
      var p = {}.hasOwnProperty;
      function n() {
        for (var r = "", e = 0; e < arguments.length; e++) {
          var a = arguments[e];
          a && (r = i(r, u.call(this, a)));
        }
        return r;
      }
      function u(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return n.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var e = "";
        for (var a in r)
          p.call(r, a) && r[a] && (e = i(e, this && this[a] || a));
        return e;
      }
      function i(r, e) {
        return e ? r ? r + " " + e : r + e : r;
      }
      t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
    })();
  }(v)), v.exports;
}
var X = W();
const k = /* @__PURE__ */ U(X), Y = {
  "purpur-accordion": "_purpur-accordion_u887g_1",
  "purpur-accordion__title": "_purpur-accordion__title_u887g_4",
  "purpur-accordion--negative": "_purpur-accordion--negative_u887g_13"
};
function rr(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var N = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var S;
function er() {
  return S || (S = 1, function(t) {
    (function() {
      var p = {}.hasOwnProperty;
      function n() {
        for (var r = "", e = 0; e < arguments.length; e++) {
          var a = arguments[e];
          a && (r = i(r, u.call(this, a)));
        }
        return r;
      }
      function u(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return n.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var e = "";
        for (var a in r)
          p.call(r, a) && r[a] && (e = i(e, this && this[a] || a));
        return e;
      }
      function i(r, e) {
        return e ? r ? r + " " + e : r + e : r;
      }
      t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
    })();
  }(N)), N.exports;
}
var tr = er();
const ar = /* @__PURE__ */ rr(tr), nr = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, pr = ar.bind(nr), j = "purpur-icon", ir = "md", ur = (t) => t.filter((p) => Object.keys(p).length >= 1).map((p) => `${p.name}="${p.value}"`).join(" "), or = ({ content: t = "", title: p } = {}) => {
  const n = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    p ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], u = p ? `<title>${p}</title>` : "";
  return `<svg ${ur(n)}>${u}${t}</svg>`;
}, cr = (t) => t.replace(/<(\/?)svg([^>]*)>/g, "").trim(), T = ({
  ["data-testid"]: t,
  svg: p,
  allyTitle: n,
  className: u,
  size: i = ir,
  ...r
}) => {
  const e = or({
    content: cr(p.svg),
    title: n
  }), a = pr(u, j, `${j}--${i}`);
  return /* @__PURE__ */ o(
    "span",
    {
      className: a,
      "data-testid": t,
      dangerouslySetInnerHTML: { __html: e },
      ...r
    }
  );
};
T.displayName = "Icon";
const sr = {
  name: "chevron-down",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M20.136 7.864a.9.9 0 0 0-1.272 0L12 14.727 5.136 7.864a.9.9 0 0 0-1.272 1.272l7.5 7.5a.9.9 0 0 0 1.272 0l7.5-7.5a.9.9 0 0 0 0-1.272Z" clip-rule="evenodd"/></svg>',
  keywords: ["chevron-down"],
  category: "utility"
}, I = (t) => /* @__PURE__ */ o(T, { ...t, svg: sr });
I.displayName = "IconChevronDown";
function _r(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var A = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var O;
function lr() {
  return O || (O = 1, function(t) {
    (function() {
      var p = {}.hasOwnProperty;
      function n() {
        for (var r = "", e = 0; e < arguments.length; e++) {
          var a = arguments[e];
          a && (r = i(r, u(a)));
        }
        return r;
      }
      function u(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return n.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var e = "";
        for (var a in r)
          p.call(r, a) && r[a] && (e = i(e, a));
        return e;
      }
      function i(r, e) {
        return e ? r ? r + " " + e : r + e : r;
      }
      t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
    })();
  }(A)), A.exports;
}
var dr = lr();
const hr = /* @__PURE__ */ _r(dr), d = {
  "purpur-paragraph": "_purpur-paragraph_1rh57_1",
  "purpur-paragraph--disabled": "_purpur-paragraph--disabled_1rh57_7",
  "purpur-paragraph--hyphens": "_purpur-paragraph--hyphens_1rh57_10",
  "purpur-paragraph--negative": "_purpur-paragraph--negative_1rh57_13",
  "purpur-paragraph--paragraph-100": "_purpur-paragraph--paragraph-100_1rh57_16",
  "purpur-paragraph--paragraph-100-medium": "_purpur-paragraph--paragraph-100-medium_1rh57_22",
  "purpur-paragraph--paragraph-100-bold": "_purpur-paragraph--paragraph-100-bold_1rh57_29",
  "purpur-paragraph--paragraph-200": "_purpur-paragraph--paragraph-200_1rh57_36",
  "purpur-paragraph--preamble-100": "_purpur-paragraph--preamble-100_1rh57_42",
  "purpur-paragraph--preamble-200": "_purpur-paragraph--preamble-200_1rh57_48",
  "purpur-paragraph--additional-100": "_purpur-paragraph--additional-100_1rh57_54",
  "purpur-paragraph--additional-100-medium": "_purpur-paragraph--additional-100-medium_1rh57_60",
  "purpur-paragraph--overline-100": "_purpur-paragraph--overline-100_1rh57_67",
  "purpur-paragraph--overline-200": "_purpur-paragraph--overline-200_1rh57_75"
}, gr = {
  PARAGRAPH100: "paragraph-100"
}, h = "purpur-paragraph", H = ({
  ["data-testid"]: t,
  children: p,
  className: n,
  disabled: u,
  enableHyphenation: i = !1,
  negative: r = !1,
  variant: e = gr.PARAGRAPH100,
  ...a
}) => {
  const s = hr([
    n,
    d[h],
    d[`${h}--${e}`],
    {
      [d[`${h}--hyphens`]]: i,
      [d[`${h}--disabled`]]: u,
      [d[`${h}--negative`]]: r
    }
  ]);
  return /* @__PURE__ */ o("p", { ...a, className: s, "data-testid": t, children: p });
};
H.displayName = "Paragraph";
const fr = {
  "purpur-accordion-item": "_purpur-accordion-item_12e59_1",
  "purpur-accordion-item__header": "_purpur-accordion-item__header_12e59_10",
  "purpur-accordion-item__trigger": "_purpur-accordion-item__trigger_12e59_13",
  "purpur-accordion-item__trigger__icon": "_purpur-accordion-item__trigger__icon_12e59_43",
  "purpur-accordion-item__title": "_purpur-accordion-item__title_12e59_49",
  "purpur-accordion-item__icon": "_purpur-accordion-item__icon_12e59_50",
  "purpur-accordion-item__rotate": "_purpur-accordion-item__rotate_12e59_64",
  "purpur-accordion-item__content": "_purpur-accordion-item__content_12e59_67",
  "purpur-accordion-item__contentText": "_purpur-accordion-item__contentText_12e59_78",
  "purpur-accordion-item--negative": "_purpur-accordion-item--negative_12e59_99"
}, l = k.bind(fr), c = "purpur-accordion-item", mr = ({
  children: t,
  className: p,
  title: n,
  titleTag: u = "h3",
  initialOpen: i = !1,
  onClick: r,
  onOpen: e,
  onClose: a,
  ...s
}) => {
  const L = z(C), g = D(), [_, R] = G(!i), B = l([
    p,
    c,
    {
      [`${c}--negative`]: L
    }
  ]);
  return /* @__PURE__ */ b("div", { className: B, ...s, children: [
    /* @__PURE__ */ o(
      $,
      {
        tag: u,
        variant: "title-100",
        className: l([`${c}__header`, `${c}__title`]),
        children: /* @__PURE__ */ b(
          "button",
          {
            type: "button",
            "data-state": _ ? "open" : "close",
            onClick: (E) => {
              r && r(E), _ ? e && e() : a && a(), R(!_);
            },
            className: l(`${c}__trigger`, p, {
              [`${c}__rotate`]: !_
            }),
            "aria-expanded": !_,
            "aria-controls": g,
            id: g + "button",
            children: [
              n,
              /* @__PURE__ */ o(I, { size: "md", className: l(`${c}__icon`), "aria-hidden": !0 })
            ]
          }
        )
      }
    ),
    /* @__PURE__ */ o(
      "div",
      {
        className: l(`${c}__content`, p),
        "aria-hidden": _,
        id: g,
        "aria-labelledby": g + "button",
        role: "region",
        children: /* @__PURE__ */ o("div", { className: l(`${c}__contentText`), children: typeof t == "string" ? /* @__PURE__ */ o(H, { variant: "paragraph-200", children: t }) : t })
      }
    )
  ] });
}, P = k.bind(Y), y = "purpur-accordion", C = F(!1), M = ({
  children: t,
  className: p,
  negative: n = !1,
  title: u,
  titleTag: i = "h2",
  titleVariant: r = "title-300",
  schema: e,
  ...a
}) => {
  const s = P([
    p,
    y,
    {
      [`${y}--negative`]: n
    }
  ]);
  return /* @__PURE__ */ b("div", { className: s, ...a, children: [
    u && /* @__PURE__ */ o($, { tag: i, variant: r, className: P(`${y}__title`), children: u }),
    /* @__PURE__ */ o(C.Provider, { value: n, children: t }),
    e && /* @__PURE__ */ o(
      "script",
      {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
          __html: e
        }
      }
    )
  ] });
};
M.Item = mr;
M.displayName = "Accordion";
export {
  M as Accordion,
  C as NegativeContext
};
//# sourceMappingURL=accordion.es.js.map
